var React = require('react');

function Responsive (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.7,70.7V39.1c0-5.8,4.7-10.4,10.4-10.4h6.3V36h-6.3C10.4,36,9,37.4,9,39.1v31.5c0,1.7,1.4,3.2,3.2,3.2h5.2V82l8.2-8.2  h38.7c1.7,0,3.2-1.4,3.2-3.2v-5.4h1.2l6,6c-0.3,5.5-4.9,9.8-10.4,9.8H28.5L16.7,92.9C16,93.7,15,94.1,14,94.1  c-2.2,0-3.9-1.8-3.9-3.9v-9.3C5.3,79.9,1.7,75.7,1.7,70.7z M98.3,16.4v31.5c0,5-3.6,9.2-8.3,10.2v9.3c0,1.1-0.5,2.1-1.2,2.9  C88,70.9,87,71.3,86,71.3c-1,0-2-0.4-2.8-1.2L71.5,58.4H35.8c-5.8,0-10.4-4.7-10.4-10.4V16.4c0-5.8,4.7-10.4,10.4-10.4h52  C93.6,5.9,98.3,10.6,98.3,16.4z M76.7,35.3l0-6.6l-3.1,0l-14,0l5.8-5.8l-4.7-4.7l-9.6,9.6l-4.2,4.2l0,0l0,0l1.2,1.2l3.5,3.5l0,0  l4.9,4.9l4.2,4.2l4.7-4.7L61.2,37l-1.6-1.6l14,0L76.7,35.3z"}));
}

Responsive.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 100 125","enableBackground":"new 0 0 100 100","xmlSpace":"preserve"};

module.exports = Responsive;

Responsive.default = Responsive;
